import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query'
import { useApi } from '../api/contexto'
import type { ErrorApi } from '../api/errores'
import type { ParteRuta } from '../api/modelos'
import { abrirPdf } from '../componentes/descargas'

/** Parte de ruta de una fecha (RF-44). `null` = aún no calculado. */
export function useParteRuta(fecha: string) {
  const api = useApi()
  return useQuery<ParteRuta | null, ErrorApi>({
    queryKey: ['ruta-dia', fecha],
    queryFn: ({ signal }) => api.pedir<ParteRuta | null>(`/api/ruta-dia/${fecha}`, { senal: signal }),
    enabled: /^\d{4}-\d{2}-\d{2}$/.test(fecha),
  })
}

/** Calcula (o recalcula, sustituyendo el parte) la ruta del día. */
export function useCalcularRuta(fecha: string) {
  const api = useApi()
  const qc = useQueryClient()
  return useMutation<ParteRuta, ErrorApi, void>({
    mutationFn: () => api.pedir<ParteRuta>(`/api/ruta-dia/${fecha}/calcular`, { metodo: 'POST' }),
    onSuccess: (parte) => qc.setQueryData(['ruta-dia', fecha], parte),
  })
}

export function usePdfRuta(fecha: string) {
  const api = useApi()
  return useMutation<void, ErrorApi, { etiqueta: string }>({
    mutationFn: async ({ etiqueta }) =>
      abrirPdf(await api.pedirArchivo(`/api/ruta-dia/${fecha}/rutas/${etiqueta}/pdf`), `ruta-${fecha}-${etiqueta}.pdf`),
  })
}
